export class ChoosedRelease {
    id: number = null;
    img: string;
    name: string;
    movieName: string;
    releaseName: string;
    isSelected: boolean = false;
    headingShown: boolean = false;
}
